export default __webpack_public_path__ + "static/media/Blog12.2.8db819b0.png";